/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnticipatedEnrollmentProgramOption
 */
export interface AnticipatedEnrollmentProgramOption {
    /**
     * 
     * @type {string}
     * @memberof AnticipatedEnrollmentProgramOption
     */
    code: AnticipatedEnrollmentProgramOptionCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof AnticipatedEnrollmentProgramOption
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AnticipatedEnrollmentProgramOption
     */
    nameJa: string;
}

/**
* @export
* @enum {string}
*/
export enum AnticipatedEnrollmentProgramOptionCodeEnum {
    GakubuGakufu = 'GakubuGakufu',
    Jtw = 'JTW',
    Jlcc = 'JLCC',
    Qpels = 'QPELS'
}

export function AnticipatedEnrollmentProgramOptionFromJSON(json: any): AnticipatedEnrollmentProgramOption {
    return AnticipatedEnrollmentProgramOptionFromJSONTyped(json, false);
}

export function AnticipatedEnrollmentProgramOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnticipatedEnrollmentProgramOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
        'nameJa': json['nameJa'],
    };
}

export function AnticipatedEnrollmentProgramOptionToJSON(value?: AnticipatedEnrollmentProgramOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
        'nameJa': value.nameJa,
    };
}


